import {Box, Tab, Tabs} from '@mui/material';
import {Route, Routes} from 'react-router-dom';
import {useLocation, useNavigate} from 'react-router';
import Recipes from './Recipes';
import Fillings from './Fillings';
import Decorations from "./Decorations";
import {DecorationDetailCard} from "./decoration/DecorationDetailCard";
import {DecorationEditPage} from "./decoration/DecorationEditPage";
import {DecorationCreatePage} from "./decoration/DecorationCreatePage";
import {FillingDetailCard} from "./filling/FillingDetailedCard";
import {FillingCreatePage} from "./filling/FillingCreatePage";
import {EditFillingHOC} from "./filling/editFilling/EditFillingHOC";
import {RecipeDetailCard} from "./recipe/RecipeDetailedCard";
import {RecipeCreatePage} from "./recipe/RecipeCreatePage";
import {EditRecipeHOC} from "./recipe/EditRecipe/EditRecipeHOC";
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";
import {ProductTypesPage} from './productTypes/ProductTypesPage';
import {ProductTypeDetailPage} from './productTypes/ProductTypeDetailPage';

function RecipesMain() {
    const history = useNavigate();
    const location = useLocation();
    const {t} = useAppTranslation();
    const tabsValue = location.pathname.startsWith('/app/recipes/product-types') ? '/app/recipes/product-types' : location.pathname;
    const handleChange = (event: any, newValue: string) => {
        history(newValue);
    };

    return (
        <Box>
            <Box sx={{mb: {xs: 2, md: 3}}}>
                <Tabs value={tabsValue} onChange={handleChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                    <Tab label={t('recipes:recipes')} value="/app/recipes"/>
                    <Tab label={t('navigation:nav_recipes_fillings')} value="/app/recipes/fillings"/>
                    <Tab label={t('navigation:nav_recipes_decorations')} value="/app/recipes/decorations"/>
                    <Tab label={t('recipes:product_types')} value="/app/recipes/product-types"/>
                </Tabs>
            </Box>

            <Routes>
                <Route index element={<Recipes/>}/>
                <Route path="new" element={<RecipeCreatePage/>}/>
                <Route path=":id" element={<RecipeDetailCard/>}/>
                <Route path=":id/edit" element={<EditRecipeHOC/>}/>
                <Route path="product-types" element={<ProductTypesPage/>}/>
                <Route path="product-types/:id" element={<ProductTypeDetailPage/>}/>
                <Route path="fillings" element={<Fillings/>}/>
                <Route path="fillings/new" element={<FillingCreatePage/>}/>
                <Route path="fillings/:id" element={<FillingDetailCard/>}/>
                <Route path="fillings/:id/edit" element={<EditFillingHOC/>}/>
                <Route path="decorations" element={<Decorations/>}/>
                <Route path="decorations/new" element={<DecorationCreatePage/>}/>
                <Route path="decorations/:id" element={<DecorationDetailCard/>}/>
                <Route path="decorations/:id/edit" element={<DecorationEditPage/>}/>
            </Routes>
        </Box>
    );
}

export default RecipesMain;
